import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import commonRu from "./locales/ru/common.json";
import commonEn from "./locales/en/common.json";

import subscriptionRu from "./locales/ru/subscription.json";
import subscriptionEn from "./locales/en/subscription.json";

import botsRu from "./locales/ru/bots.json";
import botsEn from "./locales/en/bots.json";

import navBarRu from "./locales/ru/navBar.json";
import navBarEn from "./locales/en/navBar.json";

import botsListRu from "./locales/ru/botsList.json";
import botsListEn from "./locales/en/botsList.json";

import accountRu from "./locales/ru/account.json";
import accountEn from "./locales/en/account.json";

import profileRu from "./locales/ru/profile.json";
import profileEn from "./locales/en/profile.json";

export const defaultNS = "common";

export const resources = {
  ru: {
    subscription: subscriptionRu,
    bots: botsRu,
    navBar: navBarRu,
    botsList: botsListRu,
    common: commonRu,
    account: accountRu,
    profile: profileRu,
  },
  en: {
    subscription: subscriptionEn,
    bots: botsEn,
    navBar: navBarEn,
    botsList: botsListEn,
    common: commonEn,
    account: accountEn,
    profile: profileEn,
  },
} as const;

export const LANG_KEY = "app_language";
const defaultLanguage = localStorage.getItem(LANG_KEY) || "en";

i18n.use(initReactI18next).init({
  resources,
  defaultNS,
  lng: defaultLanguage,
  fallbackLng: "en",
});

export default i18n;
